import React from "react";
import { Link, NavLink } from "react-router-dom";
import { isPayHost, mainSiteUrl } from "../../utils/host";

// On pay.* the other pages don't exist, so these links go to the main site instead.
export function SiteLink({ to, ...props }) {
  if (isPayHost()) {
    const { onClick, className, children } = props;
    return (
      <a href={mainSiteUrl(to)} onClick={onClick} className={className}>
        {children}
      </a>
    );
  }
  return <Link to={to} {...props} />;
}

export function SiteNavLink({ to, className, children, ...props }) {
  if (isPayHost()) {
    const cls = typeof className === "function" ? className({ isActive: false }) : className;
    return (
      <a href={mainSiteUrl(to)} className={cls} onClick={props.onClick}>
        {typeof children === "function" ? children({ isActive: false }) : children}
      </a>
    );
  }
  return (
    <NavLink to={to} className={className} {...props}>
      {children}
    </NavLink>
  );
}
